
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ToggleInputV2',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    capitalize: {
      type: Boolean,
      default: false
    },
    debounceDelay: {
      type: Number,
      default: 350
    }
  },
  computed: {
    modelValue: {
      get(): boolean {
        return this.value
      },
      set(value: boolean) {
        this.$emit('toggle', value)
      }
    }
  },
  model: {
    prop: 'value',
    event: 'toggle'
  },
  emits: ['debounce-click', 'toggle']
})
